export interface AppEvents {
  'capacitor::open': () => void
  'capacitor::close': () => void
  'capacitor::appUrlOpen': (event: { targetUrl: string }) => void
  'capacitor::resume': () => void
}

export const eventPluginKey = Symbol('events.bus')

export class EventBus<T extends Record<keyof T, (...args: any) => any> = AppEvents> {
  private listeners: { [K in keyof T]?: Set<T[K]> } = {}

  on<K extends keyof T>(event: K, listener: T[K]): void {
    if (!this.listeners[event]) {
      this.listeners[event] = new Set()
    }
    this.listeners[event]!.add(listener)
  }

  off<K extends keyof T>(event: K, listener: T[K]): void {
    this.listeners[event]?.delete(listener)
  }

  emit<K extends keyof T>(event: K, ...args: Parameters<T[K]>): void {
    this.listeners[event]?.forEach(fn => fn(...args))
  }
}